import type { CompositionSlice } from '../../functions/calculations/portfolioCompositionData';
import { formatCompactCurrency } from '../../functions/calculations';
import { useFilter } from '../../contexts/FilterContext';
import { useCompositionChartColors } from './compositionChartColors';

function formatSliceLabel(slice: CompositionSlice): string {
  return slice.country ? `${slice.name}, ${slice.country}` : slice.name;
}

interface CompositionPieLegendProps {
  slices: CompositionSlice[];
}

export function CompositionPieLegend({ slices }: CompositionPieLegendProps) {
  const chartColors = useCompositionChartColors();
  const { selectedCurrency } = useFilter();
  const currencyCode = selectedCurrency?.currency || 'USD';

  return (
    <ul className="composition-pie-legend" aria-label="Composition breakdown">
      {slices.map((slice, index) => (
        <li className="composition-pie-legend__item" key={`${slice.name}-${slice.country ?? ''}`}>
          <span
            className="composition-pie-legend__dot"
            style={{
              backgroundColor: chartColors[index % chartColors.length],
            }}
            aria-hidden="true"
          />
          <span className="composition-pie-legend__label">{formatSliceLabel(slice)}</span>
          <span className="composition-pie-legend__metrics">
            <span className="composition-pie-legend__value">
              {formatCompactCurrency(slice.value, currencyCode)}
            </span>
            <span className="composition-pie-legend__pct">{Math.round(slice.percentage)}%</span>
          </span>
        </li>
      ))}
    </ul>
  );
}
